
// Navigation and UI interaction utilities

export const toggleResponsiveMenu = (e?: React.MouseEvent) => {
  if (e) {
    e.preventDefault();
  }
  
  console.log("Toggling responsive menu");
  const x = document.getElementById("myTopnav");
  if (x) {
    if (x.className === "topnav") {
      x.className += " responsive";
    } else {
      x.className = "topnav";
    }
  } else {
    console.warn("Navigation element not found");
  }
};

export const initScrollRestoration = () => {
  console.log("Initializing scroll restoration");
  if (history.scrollRestoration) {
    history.scrollRestoration = 'manual';
  } else {
    window.onbeforeunload = function () {
      window.scrollTo(0, 0);
    };
  }
};

// Add new function to scroll to top on page change
export const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'auto' // Use 'auto' for immediate scrolling without animation
  });
};

// Set up global functions for navigation and interaction
export const setupGlobalFunctions = () => {
  console.log("Setting up global functions");
  if (typeof window !== 'undefined') {
    (window as any).myFunction = toggleResponsiveMenu;
  }
};
